import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconStackHorizontalAltFour20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconStackHorizontalAltFour20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 10a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M5 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0m2.65.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0 1.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4m5.15-2a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1.5 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m3.15 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1.5 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconStackHorizontalAltFour20);
